import { render } from "./zsgk.vue?vue&type=template&id=66c05ef4&scoped=true&ts=true"
import script from "./zsgk.vue?vue&type=script&lang=ts"
export * from "./zsgk.vue?vue&type=script&lang=ts"

import "./zsgk.vue?vue&type=style&index=0&id=66c05ef4&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c05ef4"]])

export default __exports__